/*
 *
 * Do not edit directly
 * Generated on Wed, 16 Jul 2025 15:14:59 GMT
 *
 */


const theme = {
  appearances: {},
  rules: [],
  tokens: {
    animationDuration: 2000,
    baseWidth: 40,
    characters: 10,
    color: '#c9c8c8',
    lineRadius: 4,
    radius: 99999999999999,
    secondColor: '#efefef',
    size: 3,
    spaceBetweenLines: 2,
    squareRadius: 4
  }
}
export default theme
